
import FastImage from "../../../../globals/elements/fastimg"
import { NavLink } from "react-router-dom"
import { publicUrlFor } from "../../../../globals/constants"
import { route } from "../../../../globals/constants"
import { parseTitle } from "../../../../utils"
export default function Service3({ options, data }) {

    console.log('service 3 options is', options)
    const title = parseTitle(options?.title)

    return (
        <div className="section-full  p-tb80 bg-full-height bg-secondry bg-repeat-x city-slide-image" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg-trans-1.png")})` }}>
            <div className="container-fluid">
                <div className="fillter-left-content">
                    <div className="filter-left-part shake_image">
                        <FastImage src={options?.image} alt="" />
                        <span className="tyre-position"><FastImage src="images/rotate-tyer.png" alt="" className="spin-tyres" /></span>
                        <FastImage className="blink-image" src={publicUrlFor("images/light-blink.png")} alt="" />
                    </div>
                    <div className="container">
                        <div className="section-head text-center sx-title-mid-area">
                            <div className="mt-box  text-white m-b30">
                                <h2 className="m-tb0">{title?.one+" "}<span className="site-text-primary">{title.two}</span> {title?.three}
                                </h2>
                                <p className="m-b15">{options.description}</p>
                            </div>
                        </div>
                        <div className=" filter-carousal-1-outer">
                            <div className="filter-carousal-1">
                                {/* IMAGE CAROUSEL START */}
                                <div className="section-content">
                                    <div className="owl-carousel owl-carousel-filter  owl-btn-vertical-center fillter-nav-left">
                                        {/* Block 1 */}
                                        {
                                            data && data.length > 0 && data.map((item,index) => {
                                                return (
                                                    <div className="item overflow-hide" key={`block-${index}`}>
                                                        <div className="mt-box">
                                                            <div className="mt-img-effect overlay-2">
                                                                <FastImage src={item?.img?.url} alt="" />
                                                                <div className="overlay-2-bg bg-black" />
                                                                <div className="overlay-2-content">
                                                                    <div className="p-a30 p-b20">
                                                                        <h4 className="m-t0 m-b15 site-text-primary">{item?.title}</h4>
                                                                        <p className="m-b20 text-white">{item?.description}</p>
                                                                        <NavLink to={route.pages.ABOUT} className="site-button">Read More</NavLink>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                        
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-center p-t30">
                            <NavLink to={route.services.SERVICES} className="site-button">Gallery</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}